<template>
    <div><div id="dom-container"></div></div>
</template>

<script>
import { getGoogleToken } from "../../../api/services/walletService.js";
import { gapi } from 'gapi-script';
export default {
  name: "GooglePay",
  props: {
    userId: String,
    storeId: String,
    msg: String,
    jwt: String,
    storeName: String,
  },
  data() {
    return {
      mountGooglePay: false,
      btnContent: ""
    };
  },
  async mounted() {
    this.$emit("update-status", true);
    var result = await getGoogleToken(this.userId, this.storeId);
    var jwt = result.data;
    this.btnContent =
      '<g:savetoandroidpay id="googlePayButton" onsuccess="successHandler" onfailure="failureHandler" size="small" textsize=large theme="dark" ref="googlePayButton" jwt=' +
      jwt +
      "></g:savetoandroidpay>";
    this.mountGooglePay = true;
    this.$forceUpdate();
    gapi.savetowallet.render("dom-container",{
      "jwt": jwt,
      "onsuccess": this.successHandler,
      "onfailure": this.failureHandler,
      size: "matchparent",
      textsize: "small",
      theme: "light",
      height: "standard"
    });
    this.$emit("update-status", false);
    // var googlePayScript = document.createElement("script");
    // googlePayScript.setAttribute(
    //   "src",
    //   "https://apis.google.com/js/platform.js"
    // );
    // document.head.appendChild(googlePayScript);
  },
  methods:{
    successHandler(err) {
      console.log(err);
    },
    failureHandler(err,err2) {
      console.log(err, err2);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
button {
  text-align: center;
  height: 40px;
  width: 100px;
}
</style>
